import QuoteViewModelProductPricingViewModel from './quoteViewModelProductPricingViewModel';

export default class QuoteProductCalculationResult {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.pricing = new QuoteViewModelProductPricingViewModel(item.pricing);
    }
  }
}
